
const paramKey = 'category';

/**
 * form category button
 */
function faqFormCategoryButton(category, faq) {
    let $el;

    /**
     * creates an element and returns it.
     */
    const render = function() {
        let preExistingCategory = faq.getParams(paramKey);
        $el = $('<a>')
            .attr('href', `?${paramKey}=${category.id}`)
            .addClass('Ge-Btn Ge-Btn--sm Ge-Btn--bar Ge-Btn--outline')
            .data('js-category-id', category.id)
            .text(category.name)
            .on('click', clicked);

        if (category.icon) {
            $el.prepend(`<span class="icon-${category.icon}"></span>`);
        }

        checkActivation(preExistingCategory);
        return $el;
    };

    const checkActivation = function(currentCategory) {
        $el
            .toggleClass('Ge-Btn--outline', category.id !== currentCategory)
            .toggleClass('Ge-Btn--blue', category.id === currentCategory);
    };

    /**
     * when the button was clicked
     */
    const clicked = function(evt) {
        evt.preventDefault();
        let current = faq.getParams('category');
        let newCategory = current !== category.id ? category.id : undefined;

        faq.setParams({
            category: newCategory,
            query: undefined,
            commonSearch: undefined,
            question: undefined
        });
    };

    // if the category param was updated
    // make the button be active if it is the same.
    faq.on('param:category', (val) => checkActivation(val));
    return { render, $el }
}

export default faqFormCategoryButton;
